<template>
  <div>
    <div class="tours-head">
      <h2>My tours</h2>
      <v-breadcrumbs :items="items">
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>

      <v-btn color="primary"
             class="create-tour-btn sh-green mb-2"
             @click="openCreateDialog">
        <v-icon left>
          mdi-plus
        </v-icon>
        New tour
      </v-btn>
    </div>

    <div v-if="tours !== undefined && paginate.total === 0" class="text-h5">
      You haven't any tours yet! Create your first tour now!
    </div>

    <v-row v-if="tours !== undefined">
      <v-col v-for="tour in tours" :key="tour.id" sm="6" md="4" lg="3" xl="3">
        <tour-card
          :to="{ name: 'cpanel.tours.scenario', params: { id: tour.id } }"
          :name="tour.name"
          :description="tour.description"
          :views="tour.views"
          :publish="tour.publish"
          :image="tour.scenes.length !== 0 ? tour.scenes[0].thumbnail || tour.scenes[0].image : undefined"
          @on-remove="remove(tour)"
        />
      </v-col>
    </v-row>
    <div v-if="paginate.total > 0" class="mt-15">
      <v-pagination
        v-model="paginate.page"
        @input="load"
        :length="Math.ceil(paginate.total / paginate.per_page)"
        circle
      ></v-pagination>
    </div>
    <!-- FORM -->
    <v-dialog
      v-model="dialog"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-card-title class="mb-2">What is New tour name?</v-card-title>
        <v-card-text class="pt-1">
          <v-row>
            <v-col cols="12">
              <v-text-field
                :disabled="loading"
                v-model="tour.name"
                label="Name"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="dialog = false" :disabled="loading">
            Close
          </v-btn>
          <v-btn color="green darken-1" text @click="create" :loading="loading">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END -->
    <confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import TourCard from '@/components/TourCard'
import ConfirmDialog from '@/components/ConfirmDialog'
export default {
  name: 'TourList',
  components: { ConfirmDialog, TourCard },
  data: () => ({
    dialog: false,
    items: [
      {
        text: 'Tours',
        disabled: false,
        href: '/tours'
      },
      {
        text: 'List',
        disabled: true
      }
    ],
    tours: undefined,
    paginate: {
      page: 1,
      per_page: 10,
      total: 0
    },
    // TODO: Create dialog
    loading: false,
    tour: {
      name: '',
      description: ''
    }
  }),
  created () {
    this.paginate.page = parseInt(this.$route.query.page || 1)
    this.load()
  },
  methods: {
    load () {
      if (this.paginate.page < 1) this.paginate.page = 1

      this.$api.tours.list(this.paginate.page).then(({ data }) => {
        this.tours = data.list
        this.paginate.per_page = data.per_page
        this.paginate.total = data.total

        this.$router.replace({ query: { page: this.paginate.page } }).catch(() => {})
      }).catch(() => {

      }).finally(() => {

      })
    },
    openCreateDialog () {
      this.tour.name = ''
      this.tour.description = ''
      this.dialog = true
    },
    create () {
      this.loading = true

      this.$api.tours.create(this.tour).then(({ data }) => {
        this.dialog = false
        this.$router.push({ name: 'cpanel.tours.scenario', params: { id: data.id } })
      }).catch(() => {

      }).finally(() => {
        this.loading = false
      })
    },
    remove (tour) {
      this.$refs.confirm.open('Remove tour?', `Do you want to remove tour "${tour.name}"?`).then((data) => {
        if (data) {
          this.$api.tours.remove(tour.id).then(() => {
            this.load()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">

</style>
